import { render, staticRenderFns } from "./split_security_reports_app.vue?vue&type=template&id=a888de18&"
import script from "./split_security_reports_app.vue?vue&type=script&lang=js&"
export * from "./split_security_reports_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports